import moment from "moment";

export const formatDateAndHour = (dateAndHour) => {
  const data = dateAndHour.split("T");
  let date = data[0].split("-");
  const hours = data[1].split(".")[0].slice(0, 5);
  date = `${date[2]}/${date[1]}/${date[0]}`;
  return { fecha: date, hora: hours };
};
/*
 * @param {Date} datetime - La fecha que queremos transformar
 *
 * @example
 * Recibimos {2024-02-15T12:20:27.902Z} y devolvemos "2024-02-15T12:20"
 *
 * @returns {string} - La fecha como string en formato YYYY-MM-DDTHH:mm
 */
export function convertDateTimeToNet(datetime) {
  return datetime ? moment(datetime).format("YYYY-MM-DDTHH:mm") : null;
}